import React from "react";
import Button from "@mui/material/Button";

// Functional component named HaqtButton, destructuring the props object to extract the buttonName prop
const HaqtButton = ({ buttonName="Button", ...props }) => {
  return (
    // Rendering a Button with props spread and displaying the buttonName as its content
    <Button style={{backgroundColor:"#0A6073"}} {...props}>{buttonName}</Button> 
  );
};

export default HaqtButton;
